import { TestPositionColor } from '../../teacher/components/Common/colors';
export var getColorByResultPosition = function (position) {
    switch (position) {
        case 'green':
            return TestPositionColor.MEETS;
        case 'yellow':
            return TestPositionColor.BELOW;
        case 'dark-green':
            return TestPositionColor.EXCEEDS;
        case 'pink':
            return TestPositionColor.FAR_BELOW;
        default:
            return '';
    }
};
